/**
 * @file 反馈页
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useCallback} from 'react';
import {Form, message} from 'antd';

import {
    fetchSubmit
} from '../../api/pages/consultationAndCooperationApi';
import {useVerifyCode} from '../../components/verify-code/verifyCodeHooks';


const useConsultationAndCooperationStore = () => {
    const {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,

        getVerifyCode
    } = useVerifyCode();

    // 校验字符串，需要同时传给后端
    const [feedbackForm] = Form.useForm();

    const submit = useCallback(async (fieldValue: any): Promise<void> => {
        const urlSearch = new URLSearchParams(window.location.search.slice(1));

        const res = await fetchSubmit({
            companyName: fieldValue.companyName,
            mainBusiness: fieldValue.mainBusiness,
            scene: fieldValue.scene,
            isUsingDLFramework: fieldValue.isUsingDLFramework,
            framework: fieldValue.framework,
            problems: fieldValue.problems,
            name: fieldValue.name,
            position: fieldValue.position,
            phoneNumber: fieldValue.phoneNumber,
            verifyCode: fieldValue.verifyCode,
            randomStr,
            source: urlSearch.get('source') || ''
        });
        // 刷新验证码
        getVerifyCode();

        if (res && res.body) {
            if (res.body.errorCode === 0) {
                // 跳转到成功页
                window.location.pathname = window.location.pathname.replace(
                    /\/consultationandcooperation$/,
                    '/consultationandcooperationsuccess'
                );
            }
            else if (res.body.errorCode === 500 && res.body.errorMsg === '验证码错误') {
                const {setFields} = feedbackForm;
                setFields([{
                    name: 'verifyCode',
                    errors: [res.body.errorMsg]
                }]);
            }
            else {
                (window as any).DEBUG && message.error(res.body.errorMsg);
            }
        }
    }, [feedbackForm, getVerifyCode, randomStr]);

    return {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,
        feedbackForm,

        getVerifyCode,
        submit
    };
};

export default useConsultationAndCooperationStore;
